import {LqdGalleryHandler} from './lqd-gallery';

class LqdDeviceGalleryHandler extends LqdGalleryHandler {

}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdDeviceGalleryHandler, { $element } );
}; 